import { Component, Input } from '@angular/core';
import { CurrencySelectionService } from 'src/app/services/currency/currency-selection.service';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css'],
})
export class ProductCardComponent {
  @Input() data: any;
  @Input() appMode: boolean = false;
   convertedPrice: number | null = null;
  currencySymbol: string = '';
  isWishlisted: boolean = false;
  private readonly wishlistKey = 'wembely_wishlist_ids';

  constructor(private currencyService: CurrencySelectionService) {}

  ngOnInit(): void {
    this.currencySymbol = this.currencyService.getSelectedCurrencySymbol();
    this.isWishlisted = this.readWishlistIds().includes(this.data?.id);
    this.currencyService.convertPrice(this.data.price).subscribe((converted) => {
      this.convertedPrice = converted;
    });

    this.currencyService.selectedCurrency$.subscribe((currency) => {
      this.currencySymbol = this.currencyService.getSelectedCurrencySymbol();
      this.currencyService.convertPrice(this.data.price).subscribe((converted) => {
        this.convertedPrice = converted;
      });
    });
  }

  get ratingValue(): number {
    const rating = Number(this.data?.rating ?? 0);
    return Number.isFinite(rating) ? rating : 0;
  }

  isStarFilled(index: number): boolean {
    return index < Math.floor(this.ratingValue);
  }

  toggleWishlist(event: Event): void {
    event.stopPropagation();
    const productId = this.data?.id;
    if (!productId || typeof window === 'undefined') {
      return;
    }

    const ids = this.readWishlistIds();
    const exists = ids.includes(productId);
    const next = exists
      ? ids.filter((id) => id !== productId)
      : [...ids, productId];
    localStorage.setItem(this.wishlistKey, JSON.stringify(next));
    this.isWishlisted = !exists;
  }

  private readWishlistIds(): string[] {
    if (typeof window === 'undefined') {
      return [];
    }
    const raw = localStorage.getItem(this.wishlistKey);
    if (!raw) {
      return [];
    }
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
